import React, { Component } from 'react';
import { Row, Col, Select } from 'antd';

class StatusFailover extends Component {
    constructor(props) {
        super(props);

        this.onChangeSelect = this.onChangeSelect.bind(this);

        this.state = {
            failover: "",
        }
    }

    componentDidMount() {

    }

    onChangeSelect(value, e) {
        this.setState({ [e.props.name]: value });
        this.props.onchange(value)
    }

    render() {
        const Option = Select.Option
        return (
            <Select
                defaultValue={0}
                name="failover"
                onChange={this.onChangeSelect}
                value={this.state.failover}
            >
                <Option name="failover" value="">Failover Status</Option>
                <Option name="failover" value="Y">Yes</Option>
                <Option name="failover" value="N">No</Option>
            </Select>
        );
    }
}

export default StatusFailover;



// WEBPACK FOOTER //
// ./src/views/Dropdown/StatusFailover.js